import isotype from "@/assets/isotype.png";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { useAtomValue } from "jotai";
import { motion } from "motion/react";
import { FC, HTMLAttributes } from "react";

type QuizUnderReviewBannerProps = HTMLAttributes<HTMLDivElement>;

// Quiz statuses that trigger the banner
const statuses = ["UNDER_REVIEW", "REVIEWED"];

const QuizUnderReviewBanner: FC<QuizUnderReviewBannerProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId: editionId,
  });

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: application?.quizId || "",
  });

  if (!quiz) {
    return null;
  }

  if (statuses.includes(quiz.status) && quiz.appealReviewCount < 1) {
    return (
      <motion.div
        className={cn(
          "flex flex-col gap-4 rounded-xl bg-[#262452] px-12 py-8 text-white lg:flex-row lg:items-center",
          props.className,
        )}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <img
          className="hidden shrink-0 lg:block"
          src={isotype}
          width={78}
          height={78}
        />

        <div className="grow">
          <h3 className="mb-2 text-2xl">El cuestionario está en revisión</h3>

          <p className="text-lg">
            Tus respuestas han sido enviadas y se evaluarán pronto. Puedes
            seguir viendo el cuestionario pero no puedes modificar las
            respuestas.
          </p>
        </div>
      </motion.div>
    );
  }
};

export default QuizUnderReviewBanner;
